import styled from "styled-components";

import disabledNotificationsIcon from "../../assets/notifications/notifications-disabled.svg";
import { DAVYS_GREY_200, DAVYS_GREY_700 } from "../common/colors";
import FlexBox from "../common/FlexBox";
import { Body2 } from "../common/Headings";

const Container = styled(FlexBox)`
  padding: 0.5rem 1rem;
  align-items: center;
  background-color: ${DAVYS_GREY_200};
  column-gap: 0.5rem;
`;

const PausedNotificationsBanner = () => {
  return (
    <Container>
      <img src={disabledNotificationsIcon} alt="notifications disabled icon" />
      <Body2 lineHeight="1rem" color={DAVYS_GREY_700}>
        Push notifications are currently snoozed on phone
      </Body2>
    </Container>
  );
};

export default PausedNotificationsBanner;
